import type { SearchClient } from 'algoliasearch';
import algoliasearch from 'algoliasearch';

import { getBrandConfig } from '@/lib/configuration/configuration';
import { ALGOLIA_APP_ID, WIDGET_ALGOLIA_API_KEY } from '@/lib/const';

export const createRetailerWidgetAlgoliaClient = (
  appId: string,
  apiKey: string,
  proxyUrl: string,
) => {
  const client = algoliasearch(appId, apiKey, {
    hosts: [
      {
        url: proxyUrl,
        protocol: 'https',
        accept: 1, // `1`: the host is read only, `2`: write only, `3`: both read and write
      },
      // for retry
      {
        url: proxyUrl,
        protocol: 'https',
        accept: 1,
      },
      {
        url: proxyUrl,
        protocol: 'https',
        accept: 1,
      },
    ],
  });

  return {
    ...client,
    search(requests: any, requestOptions: any) {
      if (getBrandConfig().disableAlgoliaApiCall) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: '',
            params: '',
          })),
        });
      }
      return client.search(requests, requestOptions);
    },
    initIndex(indexName: string) {
      const index = client.initIndex(indexName);
      if (getBrandConfig().disableAlgoliaApiCall) {
        return {
          ...index,
          search() {
            return Promise.resolve({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              hitsPerPage: 0,
              exhaustiveNbHits: false,
              query: '',
              params: '',
            });
          },
        };
      }
      return client.initIndex(indexName);
    },
  } as SearchClient;
};

const RETAILER_WIDGET_PROXY_URL =
  process.env.NEXT_PUBLIC_RETAILER_WIDGET_ALGOLIA_PROXY ||
  'www-search-tst.breitling.com';

export const retailerWidgetAlgoliaClient = createRetailerWidgetAlgoliaClient(
  ALGOLIA_APP_ID,
  WIDGET_ALGOLIA_API_KEY,
  RETAILER_WIDGET_PROXY_URL,
);
